import { Component, OnDestroy, OnInit } from '@angular/core';
import { AccountConfigurationService } from '../../services/account-configuration.service';
import { FieldTranslatedResponse } from '../../models/response/field-translated-response-input.model';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MessageDialogModalDialog } from '../errors-dialog/message-dialog-modal';
import { AccountContextService } from 'src/app/authentication/services/account-context.service';
import { AccountConfigurationType } from '../../models/enums/account-configuration-type-enum';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'project-visibility',
  templateUrl: './project-visibility.component.html',
  styleUrls: ['./project-visibility.component.scss']
})
export class ProjectVisibilityComponent implements OnInit, OnDestroy {

  constructor(
    private accountConfigurationService: AccountConfigurationService,
    private dialog: MatDialog,
    private accountContext: AccountContextService) { }

  locale: string;
  selectedOption: FieldTranslatedResponse = null;
  configurationsNameTranslated: FieldTranslatedResponse[];
  configurationRequest = "ConfigurationProjectVisibility";
  private initialSelectedOptionValue: number;
  private destroy$ = new Subject<void>();


  ngOnInit(): void {
    const account = this.accountContext.getSelectedAccountId();

    if (!account) {
      return;
    }

    var cultureName = this.locale = localStorage.getItem("lang");

    this.accountConfigurationService.getEnumTranslations(cultureName, this.configurationRequest)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        this.configurationsNameTranslated = data;
        this.loadAccountConfiguration(account);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSaveClick() {
    const account = this.accountContext.getSelectedAccountId();

    if (!account) {
      return;
    }

    this.accountConfigurationService.patchAccountConfigurations(account, [{ Type: 0, Value: this.selectedOption.Value }])
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: () => {
        this.dialog.open(MessageDialogModalDialog, {
          data: {
            title: "",
            message: "visibilityRequest.success.configurationRegisteredSuccessfully",
            isError: false
          }
        }).afterClosed()
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => {
          this.loadAccountConfiguration(account);
        });
      },
      error: (error) => {
        if (error.status == 400) {
          this.dialog.open(MessageDialogModalDialog, {
            data: {
              title: "visibility.messages.alertTitle",
              message: "visibilityRequest.errors.userIsNotAnAccountAdministrator",
              isError: true
            }
          });
        }
        if (error.status == 500) {
          this.dialog.open(MessageDialogModalDialog, {
            data: {
              title: "visibility.messages.alertTitle",
              message: "visibilityRequest.errors.internalServerError",
              isError: true
            }
          });
        }
      }
    });
  }

  onCancelClick() {
    this.setSelectedOption(this.initialSelectedOptionValue);
  }

  private loadAccountConfiguration(account: string): void {
    this.accountConfigurationService.getAccountConfigurations(account)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        const projectVisibilityConfiguration = data.ConfigurationItems
          .find(element => element.Type === AccountConfigurationType.ConfigurationProjectVisibility);

        if (!projectVisibilityConfiguration) {
          return;
        }

        this.initialSelectedOptionValue = Number(projectVisibilityConfiguration.Value);
        this.setSelectedOption(this.initialSelectedOptionValue);
      }
    });
  }

  private setSelectedOption(value: number): void {
    const selectedOption = this.configurationsNameTranslated.find(option => option.Value === value);

    if (selectedOption) {
      this.selectedOption = selectedOption;
    }
  }
}
